const DEVICE_TYPES = {
    mobile: 'mobile',
    tablet: 'tablet',
    desktop: 'desktop'
};

module.exports = {
    DEVICE_TYPES
}